import axios from 'axios';

// const API_POST_URL = 'https://your-api-url.com'; 
// const API_ROUTES_POST = {
//   posts: '/posts',
//   createPost: '/posts/create',
// };
import { API_POST_URL, API_ROUTES_POST } from '../../config/apiConfig';
// Action Types
export const FETCH_POSTS_REQUEST = 'FETCH_POSTS_REQUEST';
export const FETCH_POSTS_SUCCESS = 'FETCH_POSTS_SUCCESS';
export const FETCH_POSTS_FAILURE = 'FETCH_POSTS_FAILURE';

export const CREATE_POST_REQUEST = 'CREATE_POST_REQUEST';
export const CREATE_POST_SUCCESS = 'CREATE_POST_SUCCESS';
export const CREATE_POST_FAILURE = 'CREATE_POST_FAILURE';
export const RESET_NEW_POST = 'RESET_NEW_POST';
export const UPDATE_NEW_POST = 'UPDATE_NEW_POST';

export const LIKE_POST_REQUEST = 'LIKE_POST_REQUEST';
export const LIKE_POST_SUCCESS = 'LIKE_POST_SUCCESS';
export const LIKE_POST_FAILURE = 'LIKE_POST_FAILURE';

export const UNLIKE_POST_REQUEST = 'UNLIKE_POST_REQUEST';
export const UNLIKE_POST_SUCCESS = 'UNLIKE_POST_SUCCESS';
export const UNLIKE_POST_FAILURE = 'UNLIKE_POST_FAILURE';

export const ADD_COMMENT_REQUEST = 'ADD_COMMENT_REQUEST';
export const ADD_COMMENT_SUCCESS = 'ADD_COMMENT_SUCCESS';
export const ADD_COMMENT_FAILURE = 'ADD_COMMENT_FAILURE';

// Fetch all posts
export const fetchPosts = () => async (dispatch) => {
  dispatch({ type: FETCH_POSTS_REQUEST });
  try {
    const response = await axios.get(`${API_POST_URL}${API_ROUTES_POST.posts}`);
    dispatch({ type: FETCH_POSTS_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: FETCH_POSTS_FAILURE, error: error.message });
  }
};

// Create a new post
export const createPost = (formData) => async (dispatch) => {
  dispatch({ type: CREATE_POST_REQUEST });
  try {
    const response = await axios.post(`${API_POST_URL}${API_ROUTES_POST.createPost}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    dispatch({ type: CREATE_POST_SUCCESS, payload: response.data });
    dispatch(resetNewPost());
  } catch (error) {
    dispatch({ type: CREATE_POST_FAILURE, error: error.message });
  }
};

// Like a post
export const likePost = (postId, userCognitoId) => async (dispatch) => {
  dispatch({ type: LIKE_POST_REQUEST });
  try {
    const response = await axios.post(`${API_POST_URL}${API_ROUTES_POST.posts}/${postId}/like/`, { user_cognito_id: userCognitoId });
    dispatch({ type: LIKE_POST_SUCCESS, payload: { postId, likes: response.data.likes } });
  } catch (error) {
    dispatch({ type: LIKE_POST_FAILURE, error: error.message });
  }
};

// Unlike a post
export const unlikePost = (postId, userCognitoId) => async (dispatch) => {
  dispatch({ type: UNLIKE_POST_REQUEST });
  try {
    await axios.delete(`${API_POST_URL}${API_ROUTES_POST.posts}/${postId}/unlike/`, { data: { user_cognito_id: userCognitoId } });
    dispatch({ type: UNLIKE_POST_SUCCESS, payload: { postId } });
  } catch (error) {
    dispatch({ type: UNLIKE_POST_FAILURE, error: error.message });
  }
};

// Add a comment to a post
export const addComment = (postId, commentData) => async (dispatch) => {
  dispatch({ type: ADD_COMMENT_REQUEST });
  try {
    const response = await axios.post(`${API_POST_URL}${API_ROUTES_POST.posts}/${postId}/comments/`, commentData);
    dispatch({ type: ADD_COMMENT_SUCCESS, payload: { postId, comment: response.data } });
  } catch (error) {
    dispatch({ type: ADD_COMMENT_FAILURE, error: error.message });
  }
};

export const resetNewPost = () => ({ type: RESET_NEW_POST });

export const updateNewPost = (update) => ({ type: UPDATE_NEW_POST, payload: update });

export const setFilter = (filter) => ({
  type: 'SET_FILTER',
  payload: filter,
});
